





























import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '../../../components/Icon/Icon.vue'
import TemplateContext from '../includes/TemplateContext'
import { BreadcrumbStruct } from '../includes/types/MenuItem'
import BreadcrumbItem from "./BreadcrumbItem.vue";

@Component({
  components: {
    BreadcrumbItem,
    Icon
  },
})
export default class Breadcrumb extends Vue {
  get breadcrumbs(): Array<BreadcrumbStruct> {
    if (this.$route.meta && typeof this.$route.meta.breadcrumbs === 'function') {
      const templateContext = new TemplateContext(this.$route)

      return this.$route.meta && this.$route.meta.breadcrumbs(templateContext)
    }

    return []
  }
}
